import {useParams} from "react-router-dom";
import {resolveServiceDetail} from "@/services/services.ts";
import {
    resolveInstanceRemoteTicket as resolveInstanceVMwareConsoleRemoteTicket,
    resolveInstanceSummary
} from "@/services/instance.ts";
import {
    resolveInstanceRemoteTicket as resolveInstanceOpennebulaConsoleRemoteTicket
} from "@/pages/Service/Internal/Internal.Opennebula/connectors/instances.ts";
import qs from "qs";
import {useMemo} from "react";
import {SSH_TUNNEL} from "@/utils/constants.ts";

import GuacamoleConsole
    from "@/pages/Service/Internal/Internal.Opennebula/Instance/Detail/ManageConsole/GuacamoleConsole";
import SunstoreConsole
    from "@/pages/Service/Internal/Internal.Opennebula/Instance/Detail/ManageConsole/SunstoreConsole";

function OpennebulaConsole({service_uuid, instance_id}: any) {
    const {data} = resolveInstanceOpennebulaConsoleRemoteTicket({service_uuid, instance_id})
    const url = data?.data?.url || '';
    const token = data?.data?.token || ''
    // const zone = data?.data?.instance?.zone || ''
    const name = data?.data?.instance?.name || ''
    const client = data?.data?.client || ''

    const context = {
        name,
        url,
        token
    }

    return url && (
        <>
            {client === 'Guacamole' ? (
                <GuacamoleConsole {...context}/>
            ) : (
                <SunstoreConsole {...context}/>
            )}
        </>
    )
}

function VMwareConsole({service_uuid, instance_id}: any) {
    const {data: ticket} = resolveInstanceVMwareConsoleRemoteTicket(service_uuid, instance_id)
    const {data: summary} = resolveInstanceSummary(service_uuid, instance_id)

    // console.log(data, summary)
    const query = {
        vmId: summary?.provider?.value,
        vmName: summary?.name,
        numMksConnections: 0,
        serverGuid: summary?.provider?.serverGuid,
        locale: ticket?.acquire?.locale,
        tunnel: ticket?.acquire?.serverInfo?.name
    }

    const queryToString = qs.stringify(query, {
        encodeValuesOnly: true,
    });

    const url = useMemo(() => `${SSH_TUNNEL}/ui/webconsole.html?${queryToString}&session=${ticket?.session?.replaceAll(" ", '')}`, [queryToString, ticket?.session])

    return (<iframe src={url} width="1250" height="839" referrerPolicy="origin"/>)
}

export default function ManageConsole() {
    const {service_uuid, instance_id} = useParams()

    const {data: service} = resolveServiceDetail(service_uuid)
    const provider = service?.provider_scope

    const context = {
        service,
        service_uuid,
        instance_id
    }

    switch (provider) {
        case 'Internal.Opennebula':
            return <OpennebulaConsole {...context}/>
        case 'Internal.VMware':
            return <VMwareConsole {...context} />
    }
}